import React, { useState } from "react";
import { Container } from "react-bootstrap";
import Breadcrumbs from "../../../Common/Breadcrumbs";
import { SuccessModal } from "../../../Common/SuccessModal";
import TrialForm from "./TrialForm";
import { useTrialForm } from "./useTrialForm";
import "../AcademyEnrolments.css";

const AddTrialPage: React.FC = () => {
  const [showSuccess, setShowSuccess] = useState(false);

  const {
    form,
    loading,
    errors,
    sportOptions,
    academyOptions,
    centerOptions,
    courseOptions,
    ageCategoryOptions,
    availableDates,
    slotOptions,
    setField,
    isFormValid,
    handleSubmit,
    reset,
    navigate,
  } = useTrialForm();

  const onSubmit = async () => {
    const success = await handleSubmit();
    if (success) {
      setShowSuccess(true);
    }
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    reset();
  };

  return (
    <div className="page-content">
      <Container fluid>
        <div className="mb-3 mt-4" style={{ padding: "0 15px" }}>
          <Breadcrumbs
            items={[
              { label: "Academy" },
              {
                label: "Academy Management",
                onClick: () => navigate("/academy-enrolments"),
              },
              { label: "Add Trial", active: true },
            ]}
          />
        </div>

        <div style={{ padding: "0 15px", marginBottom: 20 }}>
          <h2 className="mb-0">Add Trial</h2>
          <p className="text-muted mb-0" style={{ fontSize: 13 }}>
            Book a free trial session for a player.
          </p>
        </div>

        <div style={{ padding: "0 15px 40px" }}>
          <TrialForm
            form={form}
            loading={loading}
            errors={errors}
            sportOptions={sportOptions}
            academyOptions={academyOptions}
            centerOptions={centerOptions}
            courseOptions={courseOptions}
            ageCategoryOptions={ageCategoryOptions}
            availableDates={availableDates}
            slotOptions={slotOptions}
            isFormValid={isFormValid}
            setField={setField}
            onSubmit={onSubmit}
          />
        </div>
      </Container>

      <SuccessModal
        show={showSuccess}
        handleClose={handleSuccessClose}
        title="Trial Booked!"
        message="The trial session has been successfully booked."
        hideButton
      />
    </div>
  );
};

export default AddTrialPage;
